import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
// import Wave from "../../../../Assets/Img/wave.png";
import Navbar from "../../../Atoms/Navbar";
// import PersonalInfoimg from "../../../../Assets/Img/personalinfoimg.png";
// import Documentimg from "../../../../Assets/Img/documentimg.png";
// import Employmentimg from "../../../../Assets/Img/employmentimg.png";
import Questions from "../../../Atoms/Question";


const SuccessFormScreen = (props) => {

  const [showPersonalDetailForm, setShowPersonalDetailForm] = useState(false);


  const PersonalInformationModel = () => {
    // Get the modal
    var modal = document.getElementById("PersonalInformationModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };
  const EmploymentDetailsModel = () => {
    // Get the modal
    var modal = document.getElementById("EmploymentDetailsModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };
  const DocumentsAttachmentModel = () => {
    // Get the modal
    var modal = document.getElementById("DocumentsAttachmentModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };
  const handlePersonalDetailForm = () => {
    window.location.href = '/AOF'
  }
  const handleWhatsapp = () => {
    window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
  }
  return (
    <>


      <>

        <Navbar />

        <div className="bg-color">
          <div className="container pt-3">
            <div className="row">
              <div className="col-md-7">
                <div className="bg-white mt-3 edge-welcome p-4">
                  <h2>Almost there</h2>
                  <p className="text-gray">
                    Your OTP has been successfully submitted! Please hold tight while we complete the remaining
                    steps to open your account. <br /> <br />

                    Once we're done, you'll receive an email from us with your trading account credentials. <br /> <br />
                  </p>

                  <div className="d-flex">

                    <button className="otp-verified btn ms-2 mb-2">
                      OTP Verified & Final Setup
                    </button>
                  </div>
                </div>
                <div className="bg-white d-none d-md-block">
                  {/* <img src={Wave} className="w-100" /> */}
                  <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/wave.png" className="w-100" />
                </div>
              </div>
              <div className="col-md-4 mt-3">
                <Questions />
                {/* <div className="bg-Pink edge px-5 px-md-3 px-lg-5 py-3">
                <h3 className="me-auto text-white fs16 fw-800">Questions?</h3>
                <p className="heading">
                  Don't hesitate to contact our support team on the following
                  channels.
                </p>
                <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                  <p
                    className="text-white fs-small"
                    style={{ fontWeight: "1000" }}
                  >
                    UAN
                  </p>
                  <p className="ms-auto text-white fs-small fw-bold">
                    021 111 639 825 Ext147
                  </p>
                </div>
                <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                  <p
                    className="text-white fs-small"
                    style={{ fontWeight: "1000" }}
                  >
                    WhatsApp
                  </p>
                  <p className="ms-auto text-white fs-small fw-bold " >
                 <a className="text-white" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a> 
                  </p>
                </div>
                <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                  <p
                    className="text-white fs-small"
                    style={{ fontWeight: "1000" }}
                  >
                    Email
                  </p>
                  <p className="ms-auto text-white fs-small fw-bold">
                    cs@nextcapital.com.pk
                  </p>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </div>


      </>


    </>
  );
};

export default SuccessFormScreen;
